import publicUrls from "../../routes/publicUrls";
import * as React from "react";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CssBaseline from "@mui/material/CssBaseline";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import "./design.css";
import Toolbar from "./toolbar";
import { Winning } from "../Model/Auction";
import { encodeId } from "../../hash";
import { C, paginationSx } from "./accountStyles";
import AccountLayout from "./components/AccountLayout";
import LotCard, { LotGrid } from "./components/LotCard";
import { EmptyState, LoadingState } from "./components/primitives";



const PER_PAGE = 12;
const PLACEHOLDER_IMG =
  "https://placehold.co/360x370?text=NO%20IMAGE%20AVAILABLE";

// Sumasakop sa <br>, <br/>, <br />, <BR>, <br  / >
const BR_TAG = /<br\s*\/?\s*>/gi;

/**
 * Pinapalitan ang anumang <br> variant ng tunay na line break (<br />).
 * Gamitin sa kahit anong field na galing sa DB na may markup.
 */
function BreakText({ text }) {
  if (text === null || text === undefined || text === "") return null;

  const lines = String(text).split(BR_TAG);

  return lines.map((line, i) => (
    <React.Fragment key={i}>
      {line}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

function WonLotCard({ lot, onClick }) {
  return (
    <LotCard
      onClick={onClick}
      image={lot.img_url === null ? PLACEHOLDER_IMG : lot.img_url}
      ratio="4 / 5"
      eyebrow={<>Lot: {lot.lot_number}{lot.auction_name ? <> · <BreakText text={lot.auction_name} /></> : null}</>}
      artist={<BreakText text={lot.artist} />}
      artistLines={2}
      title={<BreakText text={lot.title} />}
      footerLabel="Total Amount w/ Buyer’s Premium"
      footerValue={<>₱ {lot.hammer_price === null ? 0 : lot.hammer_price.toLocaleString()}</>}
    />
  );
}

function MyLots() {
  const [dataWinnging, setGetWinning] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [total, setTotal] = React.useState(0);
  const [page, setPage] = React.useState(1);

  const getWinning = async (value) => {
    setLoading(true);
    try {
      const results = await Winning(value);

      if (results.success === false) {
        setGetWinning([]);
        setTotal(0);
      } else {
        setGetWinning(results.data);
        setTotal(Math.ceil(results.pagination.total / PER_PAGE));
      }
    } catch (error) {
      // pareho sa dati: sinasalo lang ang error
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getWinning();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
    getWinning(value);
  };

  const gotoSinglePage = (slug, title, auctionId, lotNumber) => {
    const cleanTitle =
      title === null ? "untitle" : title.replace(/[^a-zA-Z0-9-_]/g, "");

    window.location.href = publicUrls.lot(
      slug.replace(/ /g, "-"),
      encodeId(auctionId),
      lotNumber,
      cleanTitle
    );
  };

  return (
    <Box>
      <CssBaseline />
      <AccountLayout title="My Lots">
        <Toolbar title={"My Lots"} />

        <Box sx={{ mt: { xs: 3, md: 5 } }}>
          {dataWinnging.length ? (
            <LotGrid>
              {dataWinnging.map((val, index) => (
                <WonLotCard
                  key={index}
                  lot={val}
                  onClick={() =>
                    gotoSinglePage(
                      val.auction_name,
                      val.title,
                      val.auction_id,
                      val.lot_number
                    )
                  }
                />
              ))}
            </LotGrid>
          ) : (
            !loading && <EmptyState title="No records found" text="Lots you win will appear here." />
          )}
        </Box>

        {loading && dataWinnging.length === 0 && <LoadingState py={8} />}

        <Stack component="nav" aria-label="My lots pages" alignItems="center" sx={{ mt: 6, pt: 4, borderTop: `1px solid ${C.line}` }}>
          <Pagination
            count={total}
            shape="rounded"
            page={page}
            onChange={handleChange}
            disabled={loading}
            sx={paginationSx}
          />
        </Stack>
      </AccountLayout>

      
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading && dataWinnging.length > 0}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default MyLots;
